import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import wasCardImg from '../was_card_img.png';
import monitoringCardImg from '../monitoring_card_img.png';
import databaseCardImg from '../database_card_img.png';
import opensourceCardImg from '../opensource_card_img.png';
import infraCardImg from '../infra_card_img.png';
import techServiceCardImg from '../techService_card_img.png';
import PartnersSection from '../components/PartnersSection';

function HomePage() {
  const [animated, setAnimated] = useState(false);
  const [heroAnimated, setHeroAnimated] = useState(false);
  const statsRef = useRef(null);

  useEffect(() => {
    // 페이지 로드 시 스크롤을 최상단으로 이동
    window.scrollTo(0, 0);
    
    // 히어로 섹션 애니메이션 시작
    const timer = setTimeout(() => {
      setHeroAnimated(true);
    }, 100);
    
    // Dropdown menu logic: Only one dropdown stays open at a time, closes instantly when moving to another
    document.querySelectorAll('.dropdown-wrapper').forEach(item => {
      let timeout;
      item.addEventListener('mouseenter', () => {
        // Close all other dropdowns instantly
        document.querySelectorAll('.dropdown-wrapper').forEach(other => {
          if (other !== item) other.classList.remove('hover');
        });
        clearTimeout(timeout);
        item.classList.add('hover');
      });
      item.addEventListener('mouseleave', () => {
        timeout = setTimeout(() => {
          item.classList.remove('hover');
        }, 200);
      });
    });

    // 숫자 애니메이션을 위한 스크롤 감지
    const handleScroll = () => {
      if (statsRef.current && !animated) {
        const rect = statsRef.current.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        
        if (rect.top < windowHeight * 0.8) {
          setAnimated(true);
          animateNumbers();
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // 초기 체크

    return () => {
      clearTimeout(timer);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [animated]);

  const animateNumbers = () => {
    const numberElements = document.querySelectorAll('.stat-number');
    
    numberElements.forEach(element => {
      const finalText = element.textContent;
      const isYear = finalText.includes('년');
      const isPlus = finalText.includes('+');
      
      // 숫자 부분만 추출
      const numberMatch = finalText.match(/\d+/);
      if (!numberMatch) return;
      
      const finalNumber = parseInt(numberMatch[0]);
      let currentNumber = 0;
      const increment = finalNumber / 50; // 50단계로 나누어 애니메이션
      
      const timer = setInterval(() => {
        currentNumber += increment;
        if (currentNumber >= finalNumber) {
          currentNumber = finalNumber;
          clearInterval(timer);
        }
        
        // 원래 형식에 맞게 텍스트 구성
        let displayText = Math.floor(currentNumber).toString();
        if (isYear) displayText += '년';
        if (isPlus) displayText += '+';
        
        element.textContent = displayText;
      }, 30); // 30ms 간격으로 업데이트
    });
  };

  return (
    <div>
      <SEO 
        title="제스트정보기술 - IT인프라솔루션 성능모니터링 전문기업"
        description="오픈소스, IT인프라 소프트웨어, 성능모니터링 전문기업. 21년 경력의 인프라소프트웨어 전문기업으로 고객과 함께 성장합니다."
      />
      {/* Hero Section */}
      <header className="hero">
        <div className={`hero-content ${heroAnimated ? 'animate' : ''}`}>
          <h2>디지털 전환(DX)은 선택이 아닌 필수가 되었습니다.</h2>
          <h2>인프라소프트웨어에서 오픈소스기반 클라우드 전환 운영서비스까지</h2>
          <h1>IT인프라솔루션 성능모니터링 전문기업</h1>
          <h2>제스트정보기술이 함께 하겠습니다.</h2>
          <a href="/xest_inf.pdf" className="btn-started" download>회사소개서 다운로드</a>
        </div>
      </header>

      <section className="company-stats" ref={statsRef}>
        <p className="stats-title">제스트정보기술은 고객과 함께 성장하고 있습니다.</p>
        <div className="stats-grid">
          <div className="stat">
            <div className="stat-number">21년</div>
            <div className="stat-label">인프라소프트웨어 경력</div>
          </div>
          <div className="stat">
            <div className="stat-number">1200+</div>
            <div className="stat-label">누적고객수</div>
          </div>
          <div className="stat">
            <div className="stat-number">50+</div>
            <div className="stat-label">DBMS 컨설팅</div>
          </div>
          <div className="stat">
            <div className="stat-number">600+</div>
            <div className="stat-label">성능모니터링 누적고객수</div>
          </div>
        </div>
      </section>

      <section className="services">
        <h2>제스트정보기술의 핵심서비스</h2>
        <p>기업 인프라 구축부터 데이터베이스, 모니터링, 오픈소스, 기술지원까지<br />제스트정보기술의 전문 솔루션과 서비스를 만나보세요.</p>
        <div className="service-cards">
          <Link to="/opensource" className="service-card">
            <div className="service-icon">
              <img src={opensourceCardImg} alt="오픈소스 기술지원" />
            </div>
            <h3>오픈소스</h3>
            <p>오픈소스 소프트웨어기반 구축 및 마이그레이션
            서비스를<br/> 제공 합니다.</p>
            <div className="service-tags">
              <span className="tag">#Rocky Linux</span>
              <span className="tag">#Tomcat</span>
              <span className="tag">#Nginx</span>
              <span className="tag">#PostgreSQL</span>
              <span className="tag">#MariaDB</span>

            </div>
          </Link>
          
          <Link to="/monitoring" className="service-card">
            <div className="service-icon">
              <img src={monitoringCardImg} alt="성능 모니터링" />
            </div>
            <h3>모니터링 & 매니지먼트</h3>
            <p>WEB/WAS,DBMS 성능모터터링 및 애플리케이션 & IT인프라 통합된 성능관리 솔루션을 제공합니다.</p>
            <div className="service-tags">
              <span className="tag">#Jennifer</span>
              <span className="tag">#MaxGauge</span>
              <span className="tag">#TAMIS</span>
              <span className="tag">#eG Enterprise</span>
            </div>
          </Link>
          
          <Link to="/solutions" className="service-card">
            <div className="service-icon">
              <img src={wasCardImg} alt="엔터프라이즈 솔루션" />
            </div>
            <h3>엔터프라이즈 솔루션</h3>
            <p>RedHat, LENA, Resin, Oracle, AgensSQL, Tibero, ClusterPlex 등 엔터프라이즈급 솔루션을 제공합니다.</p>
            <div className="service-tags">
              <span className="tag">#RedHat</span>
              <span className="tag">#LENA</span>
              <span className="tag">#Resin</span>
              <span className="tag">#Oracle</span>
              <span className="tag">#AgensSQL</span>
              <span className="tag">#Tibero</span>
            </div>
          </Link>

          <div className="service-card">
            <div className="service-icon">
              <img src={infraCardImg} alt="오픈소스 인프라" />
            </div>
            <h3>클라우드</h3>
            <p>생성형 AI 구축(LLM, sLLM) & 운영서비스 제공 <br/>
            클라우드 마이그레이션 & 관리서비스 제공</p>
            <div className="service-tags">
              <span className="tag">#생성형AI</span>
              <span className="tag">#공공클라우드</span>
              <span className="tag">#민간클라우드</span>
              <span className="tag">#디지털전환</span>
            </div>
          </div>

          <Link to="/support" className="service-card">
            <div className="service-icon">
              <img src={techServiceCardImg} alt="기술지원 서비스" />
            </div>
            <h3>케어팩 서비스</h3>
            <p>Carepack서비스를 통한 오픈소스 및 인프라SW에 대한
            기술지원/유지보수 서비스를 제공합니다</p>
            <div className="service-tags">
              <span className="tag">#케어팩</span>
              <span className="tag">#DBMS컨설팅</span>
              <span className="tag">#설치</span>
              <span className="tag">#운영</span>
              <span className="tag">#장애대응</span>
            </div>
          </Link>

          <Link to="/commercial-db" className="service-card">
            <div className="service-icon">
              <img src={databaseCardImg} alt="DBMS 성능컨설팅" />
            </div>
            <h3>DBMS 성능컨설팅 서비스</h3>
            <p>MariaDB, PostgreSQL, AgensSQL 등 데이터베이스의 성능 최적화 및 컨설팅 서비스를 제공합니다.</p>
            <div className="service-tags">
              <span className="tag">#MariaDB</span>
              <span className="tag">#PostgreSQL</span>
              <span className="tag">#Oracle</span>
              <span className="tag">#tibero</span>
              <span className="tag">#DB2</span>
            </div>
          </Link>
          
          
          
          
        </div>
      </section>

      <PartnersSection />

      <section className="location">
        <h2>오시는길</h2>
        <div className="map-wrap">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d25331.72689228166!2d126.87761016053344!3d37.47333154295277!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357b61e4c03e2569%3A0xfbe1f939d1277e7e!2z7JeQ7J207Iqk6rCA7IKw7YOA7JuM!5e0!3m2!1sko!2skr!4v1752656976769!5m2!1sko!2skr" width="100%" height="500" style={{border:0, display:'block'}} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
        </div>
      </section>

      <section className="contact-info-section">
        <div className="contact-info-container">
          <div className="contact-info-item">
            <div className="contact-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 5C3 3.89543 3.89543 3 5 3H8.27924C8.70967 3 9.09181 3.27543 9.22792 3.68377L10.7257 8.17721C10.8831 8.64932 10.6694 9.16531 10.2243 9.38787L7.96701 10.5165C9.06925 12.9612 11.0388 14.9308 13.4835 16.033L14.6121 13.7757C14.8347 13.3306 15.3507 13.1169 15.8228 13.2743L20.3162 14.7721C20.7246 14.9082 21 15.2903 21 15.7208V19C21 20.1046 20.1046 21 19 21H18C9.71573 21 3 14.2843 3 6V5Z" fill="#1a365d"/>
              </svg>
            </div>
            <div className="contact-text">
              <div className="contact-primary">Call: +02-558-5918</div>
              <div className="contact-secondary">Monday-Friday(10am-7pm)</div>
            </div>
          </div>

          <div className="contact-info-item">
            <div className="contact-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 8L10.89 13.26C11.2187 13.4793 11.6049 13.5963 12 13.5963C12.3951 13.5963 12.7813 13.4793 13.11 13.26L21 8M5 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19Z" fill="#1a365d"/>
              </svg>
            </div>
            <div className="contact-text">
              <div className="contact-primary">sales@xest.kr</div>
              <div className="contact-secondary">Web: <a href="http://www.xest.kr" target="_blank" rel="noopener noreferrer" style={{color: 'inherit', textDecoration: 'none'}}>www.xest.kr</a></div>
            </div>
          </div>

          <div className="contact-info-item">
            <div className="contact-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 10C21 17 12 23 12 23S3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z" fill="#1a365d"/>
                <path d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z" fill="white"/>
              </svg>
            </div>
            <div className="contact-text">
              <div className="contact-primary">우 08505 서울특별시 금천시 디지털로 121</div>
              <div className="contact-secondary">에이스가산타워 7층 703호</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default HomePage; 